var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1.5H19C22.0376 1.5 24.5 3.96243 24.5 7V19C24.5 22.0376 22.0376 24.5 19 24.5H12.5455V15H17.2658C17.4034 15 17.5234 14.9063 17.5568 14.7728L17.9068 13.3728C17.9541 13.1834 17.8109 13 17.6158 13H12.5455C12.5455 6.98727 13.8923 6.9905 17.5582 6.9993C17.6047 6.99941 17.6516 6.99953 17.6989 6.99963C17.8646 6.99998 18 6.86569 18 6.7V5.3C18 5.13431 17.8624 4.99987 17.6967 5.00114C11.919 5.04544 10.421 6.4031 10.3756 12.6961C10.3744 12.8618 10.2402 13 10.0745 13H6.17695C6.01127 13 5.87695 13.1343 5.87695 13.3V14.7C5.87695 14.8657 6.01127 15 6.17695 15H10.3745L10.3642 24.5H7C3.96243 24.5 1.5 22.0376 1.5 19V7C1.5 3.96243 3.96243 1.5 7 1.5ZM0 7C0 3.13401 3.13401 0 7 0H19C22.866 0 26 3.13401 26 7V19C26 22.866 22.866 26 19 26H7C3.13401 26 0 22.866 0 19V7Z",
    fill: "#9F9F9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.615614841a3870bbca4ec31d27e25fc2.svg";
export { ForwardRef as ReactComponent };